import { waLink, WHATSAPP_DISPLAY } from "../../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#05030A] py-14">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-3 gap-10">
      <div>
        <span className="block font-serif text-2xl text-[#F3EFE7]">Clarividencia Luz Sagrada</span>
        <span className="block text-xs uppercase tracking-[0.25em] text-[#C5A059] mt-1">Tarotista fiable · Asturias</span>
        <p className="mt-4 text-sm text-white/60 max-w-xs leading-relaxed">
          Vidente sin gabinete con más de 26 años de experiencia. Tarot, retornos de pareja,
          limpiezas y trabajo espiritual.
        </p>
      </div>
      <div>
        <h4 className="text-sm uppercase tracking-[0.2em] text-white/50">Contacto</h4>
        <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp"
          className="mt-4 block text-[#C5A059] hover:text-[#D4AF37] transition-colors">{WHATSAPP_DISPLAY}</a>
        <p className="mt-2 text-sm text-white/60">Consulta presencial · Solo Asturias</p>
        <p className="text-sm text-white/60">Sin gabinetes ni intermediarios</p>
      </div>
      <div>
        <h4 className="text-sm uppercase tracking-[0.2em] text-white/50">Servicios destacados</h4>
        <ul className="mt-4 space-y-1 text-sm text-white/60">
          <li>Tarot y clarividencia</li>
          <li>Retornos de pareja</li>
          <li>Limpiezas y despojos</li>
          <li>Tumbabrujería y abre caminos</li>
        </ul>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-10 pt-6 border-t border-white/5 text-xs text-white/40">
      © {new Date().getFullYear()} Clarividencia Luz Sagrada · Todos los derechos reservados.
    </div>
  </footer>
);
